import { useRepo } from 'pinia-orm';
import { Experiment } from './Experiment';
import { Website } from './Website';
import { Variation } from './Variation';
import { Page, UrlRule } from './Page';
import { Goal } from './Goal';

// Export models
export { Experiment, Website, Variation, Page, UrlRule, Goal };

// Export repository functions
export const useExperimentRepo = () => useRepo(Experiment);
export const useWebsiteRepo = () => useRepo(Website);
export const useVariationRepo = () => useRepo(Variation);
export const usePageRepo = () => useRepo(Page);
export const useUrlRuleRepo = () => useRepo(UrlRule);
export const useGoalRepo = () => useRepo(Goal);
